<script>
export default {
  name: "NotFound",
  mounted() {
  }
}
</script>

<template>
  <div class="wrapper-content left flex flex-xy-center">
    <div class="not-found-block left">
      <span class="not-found-404 left flex flex-xy-center">404</span>
      <span class="not-found-text left flex flex-xy-center">страница не найдена</span>
    </div>
  </div>
</template>

<style scoped>

</style>